import { themeVars } from '@coverflex-tech/hypernova';
import { style } from '@vanilla-extract/css';

const root = style({
  display: 'flex',
  flexDirection: 'column',
  gap: themeVars.spacing.sm,
});

const toggle = style({
  textDecoration: 'underline',
  cursor: 'pointer',
});

const row = style({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  gap: themeVars.spacing.md,
});

const endText = style({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%',
});

const startText = style({
  minWidth: 'fit-content',
});

export const css = {
  root,
  toggle,
  row,
  endText,
  startText,
};
